export default defineNuxtRouteMiddleware(async (to) => {
  const user = useSupabaseUser()

  // Add debugging
  console.log('Auth middleware:', { 
    path: to.path, 
    user: user.value ? 'logged in' : 'not logged in'
  })

  // Public routes that don't require authentication
  const publicRoutes = ['/', '/login', '/waitlist', '/forgot-password', '/screenshots']
  if (publicRoutes.includes(to.path)) {
    return
  }

  // Auth routes that handle their own validation
  if (to.path.startsWith('/auth/')) {
    return
  }

  // Check if user is authenticated for protected routes
  if (!user.value) {
    return navigateTo('/login')
  }
})
